
export const speciality = [
  { value: "", label: "Select Specialty" },
  {
    value: "Obstetricis and Gynecology",
    label: "Obstetricis and Gynecology",
  },
  { value: "Cardiology", label: "Cardiology" },
  { value: "Endocrinology", label: "Endocrinology" },
  { value: "Gastroenterology", label: "Gastroenterology" },
  { value: "Hematology", label: "Hematology" },
  { value: "Infectious Disease", label: "Infectious Disease" },
  { value: "Nephrology", label: "Nephrology" },
  { value: "Oncology", label: "Oncology" },
  { value: "Pulmonology", label: "Pulmonology" },
  { value: "Rheumatology", label: "Rheumatology" },
  { value: "General Surgery", label: "General Surgery" },
  {
    value: "Cardiothoracic Surgery",
    label: "Cardiothoracic Surgery",
  },
  { value: "Neurosurgery", label: "Neurosurgery" },
  { value: "Orthopedic Surgery", label: "Orthopedic Surgery" },
  { value: "Ophthalmology", label: "Ophthalmology" },
  {
    value: "Otolaryngolory (ENT)",
    label: "Otolaryngolory (ENT)",
  },
  { value: "Plastic Surgery", label: "Plastic Surgery" },
  { value: "Vascular Surgery", label: "Vascular Surgery" },
  { value: "Neonatology", label: "Neonatology" },
  { value: "Psychiatry", label: "Psychiatry" },
  { value: "Dermatology", label: "Dermatology" },
  { value: "Radiology", label: "Radiology" },
  {
    value: "General Anesthesiology",
    label: "General Anesthesiology",
  },
  { value: "Neurology", label: "Neurology" },
  { value: "Ophthalmology", label: "Ophthalmology" },
  { value: "Pathology", label: "Pathology" },
  {
    value: "Family Medicine (GP)",
    label: "Family Medicine (GP)",
  },
  { value: "No Specialty", label: "No Specialty" },
];

export const medicType = [
  { value: "", label: "Select a Medic type" },
  { value: "doctor", label: "Doctors" },
  { value: "nurse", label: "Nurses" },
  { value: "midwife", label: "Midwife" },
  { value: "nurse/midwife", label: "Nurses/Midwife" },
];

export const jobTitle = [
  { value: "", label: "Select a title" },
  { value: "Doctors", label: "Doctors" },
  { value: "Nurses", label: "Nurses" },
  { value: "Midwife", label: "Midwife" },
  { value: "Nurses/Midwife", label: "Nurses/Midwife" },
  { value: "Medical Doctor", label: "Medical Doctor" },
  {
    value: "Local Doctor",
    label: "Local Doctor",
  },
];
export const departmentOptions = [
  { value: "", label: "Select a department" },
  { value: "General Medicine", label: "General Medicine" },
  { value: "Surgery", label: "Surgery" },
  {
    value: "Obstetrics and Gynecology (O & G)",
    label: "Obstetrics and Gynecology (O & G)",
  },
  { value: "Pediatrics", label: "Pediatrics" },
  { value: "Radiology/Imaging", label: "Radiology/Imaging" },
  { value: "Pharmacy", label: "Pharmacy" },
  { value: "Labortory Services", label: "Labortory Services" },
  {
    value: "Emergency Department (A & E)",
    label: "Emergency Department (A & E)",
  },
  { value: "Internal Medicine", label: "Internal Medicine" },

  { value: "Intensive Care Unit (ICU)", label: "Intensive Care Unit (ICU)" },
  { value: "Anesthesia", label: "Anesthesia" },

  { value: "Orthopedics", label: "Orthopedics" },
  {
    value: "Physiotheraphy/Rehabilitation",
    label: "Physiotheraphy/Rehabilitation",
  },
  { value: "Dental Care", label: "Dental Care" },
  { value: "Ophthalmology (Eye Care)", label: "Ophthalmology (Eye Care)" },
  {
    value: "Ear, Nose, and Throat (ENT)",
    label: "Ear, Nose, and Throat (ENT)",
  },
  { value: "Dermatology", label: "Dermatology" },
  { value: "Urology", label: "Urology" },
  { value: "Oncology", label: "Oncology" },
  { value: "Mental Health/Psychiatry", label: "Mental Health/Psychiatry" },
  {
    value: "Dietary and Nutrition Services",
    label: "Dietary and Nutrition Services",
  },
  { value: "Administration and Billing", label: "Administration and Billing" },
  { value: "Infection Control", label: "Infection Control" },
  {
    value: "Outpatient Department (OPD)",
    label: "Outpatient Department (OPD)",
  },
  { value: "Nephrology/Dialysis Unit", label: "Nephrology/Dialysis Unit" },
  { value: "Geriatrics", label: "Geriatrics" },
  {
    value: "Family Planning and Reproductive Health",
    label: "Family Planning and Reproductive Health",
  },
  {
    value: "Public Health/Preventive Care",
    label: "Public Health/Preventive Care",
  },
  { value: "Other", label: "Other ()" },
];